module.exports = __webpack_public_path__ + "static/images/styles/images/events/event-challenge.5089199f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/events/event-challenge.png
// module id = 3625
// module chunks = 11